// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wRQU-","row":"styles_row__O4Y9S"};